'use client';
import { useEffect } from "react";

import { TagItemType } from "@/lib/schema";

import { useFetch } from "./useFetch/useFetch";

export function useTag() {
  const [fetchTags, {data, loading, error}] = useFetch<{ data: TagItemType[] } | null>();

  useEffect(() => {
    fetchTags("/tag", {next: {tags: ["tags"]}});
  }, []);

  return {tags: data?.data || [], error, loading}
}